import { Controller } from "@hotwired/stimulus"

// Admin Edit User (Phelipe 2026-10-20): picking a company that is somebody's
// Owner's Rep asks before saving — the person keeps every project and the
// new company joins each as Owner's Rep (or Stakeholder where the owner
// hasn't listed it). Any other company change saves as before.
export default class extends Controller {
  static targets = ["form", "companySelect", "moveFlag", "modal", "summary", "list"]
  static values = { previewUrl: String, originalCompanyId: String }

  async beforeSubmit(event) {
    if (this._confirmed) return
    const picked = this.companySelectTarget.value
    if (!picked || picked === this.originalCompanyIdValue) return

    event.preventDefault()
    let preview = null
    try {
      const resp = await fetch(`${this.previewUrlValue}?company_id=${encodeURIComponent(picked)}`, { headers: { Accept: "application/json" } })
      if (resp.ok) preview = await resp.json()
    } catch { /* fall through: save as usual */ }

    if (!preview || !preview.applicable) {
      this._submit()
      return
    }
    this._render(preview)
    this.modalTarget.classList.remove("hidden")
  }

  confirm() {
    this.moveFlagTarget.value = "1"
    this.modalTarget.classList.add("hidden")
    this._submit()
  }

  hideModal() { this.modalTarget.classList.add("hidden") }
  stopPropagation(event) { event.stopPropagation() }

  _submit() {
    this._confirmed = true
    this.formTarget.requestSubmit()
  }

  _render(p) {
    const total = p.projects.length
    const who = p.user_name || "This person"
    if (total === 0) {
      this.summaryTarget.textContent = `${who} isn't on any project outside ${p.company_name}. They'll simply move to ${p.company_name}.`
    } else {
      const parts = []
      if (p.rep_count) parts.push(`${p.company_name} will be added as Owner's Rep on ${p.rep_count} of them`)
      if (p.other_count) parts.push(`${p.other_count} ${p.other_count === 1 ? "owner doesn't" : "owners don't"} list ${p.company_name} as an Owner's Rep, so it joins those as Stakeholder`)
      let past = ""
      if (p.past_prs_count) past = ` On ${p.past_prs_count} of them ${p.company_name} has pay requests: they become Past PRs, which the owner side can delete or add to. Cancel if you'd rather fix those first.`
      this.summaryTarget.textContent = `${who} is a member of ${total} project${total === 1 ? "" : "s"}. ${parts.join("; ")}. ${who} stays on every project.${past}`
    }
    const label = { rep: "Owner's Rep", already_rep: "Owner's Rep (already)", rep_past_prs: "Owner's Rep · PRs become Past PRs", stakeholder: "Stakeholder", keeps_role: "Keeps current role" }
    const cls = { rep: "bg-emerald-100 text-emerald-700", already_rep: "bg-emerald-50 text-emerald-600", rep_past_prs: "bg-amber-100 text-amber-700", stakeholder: "bg-amber-100 text-amber-700", keeps_role: "bg-gray-100 text-gray-600" }
    this.listTarget.innerHTML = p.projects.map(pr => `
      <div class="flex items-center justify-between gap-3 py-1 border-b border-gray-100">
        <div class="min-w-0 truncate"><span class="font-medium text-text-heading">${this._esc(pr.number ? `${pr.number} - ${pr.name}` : pr.name)}</span>
          <span class="text-text-muted"> · ${this._esc(pr.owner || "")}</span></div>
        <span class="shrink-0 px-2 py-0.5 rounded-full text-[13px] font-medium ${cls[pr.outcome] || cls.keeps_role}">${label[pr.outcome] || pr.outcome}</span>
      </div>`).join("")
  }

  _esc(s) {
    return String(s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]))
  }
}
